export const reduxKeyBuyer = '@@ADOPTS_BUYER';
export const reduxKeySeller = '@@ADOPTS_SELLER';
export const i18nNamespace = 'adopts';
export var AdoptsModalType;
(function(AdoptsModalType) {
    AdoptsModalType["SELLER_MODAL"] = "ADOPT_SELLER_MODAL";
    AdoptsModalType["BUYER_MODAL"] = "ADOPT_BUYER_MODAL";
    AdoptsModalType["TRANSACTION_HISTORY_MODAL"] = "EXCLUSIVE_TRANSACTION_HISTORY_MODAL";
    AdoptsModalType["RESALE_WAIT_WINDOW_MODAL"] = "EXCLUSIVE_RESALE_WAIT_WINDOW_MODAL";
})(AdoptsModalType || (AdoptsModalType = {}));
